import { createSlice } from "@reduxjs/toolkit";
import MyTeamSummary from "../../../pages/Ats/Leads/Lead/MyTeamSummary";
import { get } from "lodash";

const initialState = {
  loading: false,
  error: null,

  teamLead: {
    today: {
      data: [],
      total: 0,
    },
    yesterday: {
      data: [],
      total: 0,
    },
  },

  company: {
    current: null,
    list: [],
    newCompanyUiid: null,
  },

  search: {
    results: [],
    type: null,
  },
  leads: {
    companies: [],
    totalCount: 0,
  },
  companyJobCounts: {
    loading:false,
    today: { data: [], total: 0 },
    yesterday: { data: [], total: 0 },
  },

  raSettings: {
    data: [],
    total: 0,
    current: null,
  },
  prospects: {
    data: [],
    total: 0,
  },
  dailyProduction: {
    data: [],
  },
  allLeads: {
    data: [],
  },
  teamLeads: {
    data: [],
  },
  teamProspects: {
    data: [],
    total: 0,
  },
  MyTeamSummary:{
    data: [],
    total: 0,
    totalData :[]
  },
  MyTeamSummaryCounts: {
    loading:false,
    today: { data: [], total: 0 },
    yesterday: { data: [], total: 0 },
  }
};

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    getTodaysTeamLeadStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getTodaysTeamLeadSuccess(state, action) {
      state.loading = false;
      state.teamLead.today.data = action.payload.data || [];
      state.teamLead.today.total = action.payload.total || 0;
    },
    getTodaysTeamLeadFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getYesterdaysTeamLeadStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getYesterdaysTeamLeadSuccess(state, action) {
      state.loading = false;
      state.teamLead.yesterday.data = action.payload.data || [];
      state.teamLead.yesterday.total = action.payload.total || 0;
    },
    getYesterdaysTeamLeadFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    clearTeamLead(state) {
      state.teamLead.today = { data: [], total: 0 };
      state.teamLead.yesterday = { data: [], total: 0 };
      state.loading = false;
      state.error = null;
    },

    addCompanyStart(state) {
      state.loading = true;
      state.error = null;
    },
    addCompanySuccess(state, action) {
      state.loading = false;
      state.company.current = action.payload;
      state.company.newCompanyUiid = action.payload.uiid;
      state.company.list.push(action.payload);
    },
    addCompanyFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCompanyStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCompanySuccess(state, action) {
      state.loading = false;
      state.company.current = action.payload;
    },
    fetchCompanyFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addJobStart(state) {
      state.loading = true;
      state.error = null;
    },
    addJobSuccess(state) {
      state.loading = false;
    },
    addJobFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteJobStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteJobSuccess(state, action) {
      state.loading = false;
      const { companyId, jobUiid } = action.payload;
      const company = state.company.list.find((c) => c._id === companyId);
      if (company && company.jobs) {
        company.jobs = company.jobs.filter((job) => job.uiid !== jobUiid);
      }
    },
    deleteJobFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearCompany(state) {
      state.company.current = null;
      state.company.list = [];
      state.loading = false;
      state.error = null;
      state.company.newCompanyUuid = null;
    },

    searchStart(state) {
      state.loading = true;
      state.error = null;
      state.search.results = [];
      state.search.type = null;
    },
    searchSuccess(state, action) {
      state.loading = false;
      state.search.results = action.payload.data || [];
      state.search.type = action.payload.type || null;
    },
    searchFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearSearch(state) {
      state.loading = false;
      state.search.results = [];
      state.search.type = null;
      state.error = null;
    },

    getTodaysCompaniesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getYesterdayCompaniesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTodaysCompaniesSuccess(state, action) {
      state.loading = false;
      state.leads.companies = state.leads.companies = (
        action.payload?.data || []
      ).map((item) => ({
        ...item,
        jobs: Array.isArray(item.jobs)
          ? item.jobs
          : item.jobs
          ? [item.jobs]
          : [],
      }));
      state.leads.totalCount =
        action.payload?.totalCount || action.payload?.data?.length || 0;
    },
    getTodaysCompaniesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateJobDeatilsStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateJobDeatilsSucess(state) {
      state.loading = false;
      state.error = null;
    },
    updateFailureSuccess(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getTodaysCompanyJobCountsStart(state) {
      state.loading = true;
      state.companyJobCounts.loading = true;
      state.error = null;
    },
    getTodaysCompanyJobCountsSuccess(state, action) {
      state.loading = false;
      state.companyJobCounts.loading = false;
      state.companyJobCounts.today.data = action.payload.data || [];
      state.companyJobCounts.today.total = action.payload.total || 0;
    },
    getTodaysCompanyJobCountsFailure(state, action) {
      state.loading = false;
      state.companyJobCounts.loading = false;
      state.error = action.payload;
    },

    getYesterdaysCompanyJobCountsStart(state) {
      state.loading = true;
      state.companyJobCounts.loading = true;
      state.error = null;
    },
    getYesterdaysCompanyJobCountsSuccess(state, action) {
      state.loading = false;
      state.companyJobCounts.loading = false;
      state.companyJobCounts.yesterday.data = action.payload.data || [];
      state.companyJobCounts.yesterday.total = action.payload.total || 0;
    },
    getYesterdaysCompanyJobCountsFailure(state, action) {
      state.loading = false;
      state.companyJobCounts.loading = false;
      state.error = action.payload;
    },

    clearCompanyJobCounts(state) {
      state.companyJobCounts.today = { data: [], total: 0 };
      state.companyJobCounts.yesterday = { data: [], total: 0 };
      state.loading = false;
      state.companyJobCounts.loading = false;
      state.error = null;
    },

    //Bulk Upload
    bulkUploadStart(state) {
      state.loading = true;
      state.error = null;
    },
    bulkUploadSuccess(state, action) {
      state.loading = false;
      state.bulkUpload.data = action.payload.data || [];
      state.bulkUpload.total =
        action.payload.total || action.payload.data.length || 0;
    },
    bulkUploadFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearBulkUpload(state) {
      state.bulkUpload = { data: [], total: 0 };
      state.loading = false;
      state.error = null;
    },
    // RA Settings// RA Settings
    getRaSettingsStart(state) {
      state.loading = true;
      state.error = null;
    },

    getRaSettingsSuccess(state, action) {
      state.loading = false;
      state.raSettings.data = action.payload.data || [];
      state.raSettings.total = action.payload.total || 0;
      // set the first setting as default
      state.raSettings.current = action.payload.data?.[0]?.raSetting || null;
    },
    getRaSettingsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearRaSettings(state) {
      state.raSettings = { data: [], total: 0, current: null };
      state.loading = false;
      state.error = null;
    },

    saveRaSettingsStart: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    saveRaSettingsSuccess: (state, action) => {
      state.loading = false;
      state.raSettings.current = action.payload;
    },

    saveRaSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateRaSettingsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateRaSettingsSuccess: (state, action) => {
      state.loading = false;
      state.raSettings.current = action.payload; // updated raSetting
    },

    updateRaSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    //update company status
    updateCompanyStatusStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCompanyStatusSuccess: (state, action) => {
      state.loading = false;
      const updatedCompany = action.payload;
      // update current company if matches
      if (state.company.current?.uiid === updatedCompany.uiid) {
        state.company.current = { ...state.company.current, ...updatedCompany };
      }
      // update company in list
      state.company.list = state.company.list.map((c) =>
        c.uiid === updatedCompany.uiid ? { ...c, ...updatedCompany } : c
      );
    },
    updateCompanyStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    //PROSPECTS
    // Prospects
    getProspectsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTeamProspectsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTeamProspectsCountStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTeamProspectsCountSuccess(state, action) {
      state.loading = false;
      state.teamProspects.total =action.payload;
    }
    ,
    getProspectsSuccess(state, action) {
      state.loading = false;
      state.prospects.data = action.payload.data || [];
      state.prospects.total =
        action.payload.total || action.payload.data?.length || 0;
    },
    getTeamProspectsSuccess(state, action) {
      state.loading = false;
      state.teamProspects.data = action.payload || [];
    },
    getProspectsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getTeamProspectsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearProspects(state) {
      state.prospects = { data: [], total: 0 };
      state.loading = false;
      state.error = null;
    },
    //daily production
    getDailyProductionStart(state) {
      state.loading = true;
      state.error = null;
    },
    getDailyProductionSuccess(state, action) {
      state.loading = false;
      state.dailyProduction.data = action.payload.data || [];
    },
    getDailyProductionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch all leads
    fetchAllLeadsStart(state) {
      state.loading = true;
      state.error = null;
      state.allLeads.data = [];
      state.allLeads.total = 0;
    },
    fetchTeamLeadsStart(state) {
      state.loading = true;
      state.error = null;
      state.teamLeads.data = [];
      state.teamLeads.total = 0;
    },
    fetchAllLeadsSuccess(state, action) {
      state.loading = false;
      state.allLeads.data = action.payload.data || [];
      state.allLeads.total =
        action.payload.total || action.payload.data?.length || 0;
    },
    fetchTeamLeadsSuccess(state, action) {
      state.loading = false;
      state.teamLeads.data = action.payload.data || [];
      state.teamLeads.total =
        action.payload.total || action.payload.data?.length || 0;
    },
    fetchAllLeadsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchTeamLeadsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearAllLeads(state) {
      state.allLeads.data = [];
      state.allLeads.total = 0;
      state.loading = false;
      state.error = null;
    },
    clearTeamLeads(state) {
      state.teamLeads.data = [];
      state.teamLeads.total = 0;
      state.loading = false;
      state.error = null;
    },
    fetchMyTeamSummaryStart(state) {
       state.loading = true;
    },
      myTeamSummarySuccess(state,action) {
       state.loading = false;
       state.MyTeamSummary.data = action.payload.data
    },
     myTeamSummaryFailure(state,action) {
       state.loading = false;
    },
    fetchTodayTeamSummaryStart(state){
      state.loading = true;
      state.MyTeamSummaryCounts.loading = true;
    },
    todayTeamSummarySuccess(state,action){
      state.MyTeamSummaryCounts.loading = false;
      state.MyTeamSummaryCounts.today.data = action.payload.data
    },
    todayTeamSummaryFailure(state,action){
     state.loading = false;
     state.MyTeamSummaryCounts.loading = false;
    },
      fetchYesterdayTeamSummaryStart(state){
      state.loading = true;
      state.MyTeamSummaryCounts.loading = true;
    },
    yesterdayTeamSummarySuccess(state,action){
      state.MyTeamSummaryCounts.loading = false;
      state.MyTeamSummaryCounts.yesterday.data = action.payload.data
    },
    yesterdayTeamSummaryFailure(state,action){
      state.loading = false;
      state.MyTeamSummaryCounts.loading = false;
    },
       fetchTotalMyTeamSummaryStart(state) {
       state.loading = true;
    },
      totalmyTeamSummarySuccess(state,action) {
       state.loading = false;
       state.MyTeamSummary.totalData = action.payload.data
    },
     totalmyTeamSummaryFailure(state,action) {
       state.loading = false;
    },
  },
});

export const {
  getTodaysTeamLeadStart,
  getTodaysTeamLeadSuccess,
  getTodaysTeamLeadFailure,
  getYesterdaysTeamLeadStart,
  getYesterdaysTeamLeadSuccess,
  getYesterdaysTeamLeadFailure,
  clearTeamLead,

  addCompanyStart,
  addCompanySuccess,
  addCompanyFailure,
  fetchCompanyStart,
  fetchCompanySuccess,
  fetchCompanyFailure,
  addJobStart,
  addJobSuccess,
  addJobFailure,
  deleteJobStart,
  deleteJobSuccess,
  deleteJobFailure,
  clearCompany,

  searchStart,
  searchSuccess,
  searchFailure,
  clearSearch,

  getTodaysCompaniesStart,
  getTodaysCompaniesSuccess,
  getTodaysCompaniesFailure,
  updateJobDeatilsStart,
  updateJobDeatilsSucess,
  updateFailureSuccess,

  getTodaysCompanyJobCountsStart,
  getTodaysCompanyJobCountsSuccess,
  getTodaysCompanyJobCountsFailure,
  getYesterdaysCompanyJobCountsStart,
  getYesterdaysCompanyJobCountsSuccess,
  getYesterdaysCompanyJobCountsFailure,
  clearCompanyJobCounts,

  bulkUploadStart,
  bulkUploadSuccess,
  bulkUploadFailure,
  clearBulkUpload,
  // RA Settings
  getRaSettingsStart,
  getRaSettingsSuccess,
  getRaSettingsFailure,
  clearRaSettings,
  saveRaSettingsStart,
  saveRaSettingsSuccess,
  saveRaSettingsFailure,
  updateRaSettingsStart,
  updateRaSettingsSuccess,
  updateRaSettingsFailure,
  //company status

  updateCompanyStatusStart,
  updateCompanyStatusSuccess,
  updateCompanyStatusFailure,
  //PROSPECTS
  getProspectsStart,
  getProspectsSuccess,
  getProspectsFailure,
  clearProspects,
  //daiy production
  getDailyProductionStart,
  getDailyProductionSuccess,
  getDailyProductionFailure,
  //all leads
  fetchAllLeadsStart,
  fetchAllLeadsSuccess,
  fetchAllLeadsFailure,
  clearAllLeads,
  fetchTeamLeadsSuccess,
  fetchTeamLeadsFailure,
  clearTeamLeads,
  fetchTeamLeadsStart,
  getTeamProspectsStart,
  getTeamProspectsSuccess,
  getTeamProspectsFailure,
  //my team summary
  fetchMyTeamSummaryStart,
  myTeamSummarySuccess,
  myTeamSummaryFailure,
  fetchTodayTeamSummaryStart,
  todayTeamSummarySuccess,
  todayTeamSummaryFailure,
  fetchYesterdayTeamSummaryStart,
  yesterdayTeamSummarySuccess,
  yesterdayTeamSummaryFailure,
  fetchTotalMyTeamSummaryStart,
  totalmyTeamSummarySuccess,
  totalmyTeamSummaryFailure,
  getTeamProspectsCountStart,
  getTeamProspectsCountSuccess
} = leadsSlice.actions;

export default leadsSlice.reducer;
